// sign-info-wrapper.component.ts

import { Component, Input } from '@angular/core';
import IPBoard from '../../../model/product/ip-board/ip-board';

type InfoType = 'immo' | 'installer' | 'graphical' | 'atelier';

@Component({
  selector: 'sign-info-wrapper',
  template: `
    <ng-container
      *ngIf="
        !client &&
        (ipBoard?.boardPart?.sign || ipBoard?.otherSideBoardPart?.sign)
      "
    >
      <sign-info
        [signDetail]="ipBoard?.boardPart?.sign"
        [signStickerDetail]="ipBoard?.boardPart?.sticker"
        [otherSideSignDetail]="ipBoard?.otherSideBoardPart?.sign"
        [otherSideSignStickerDetail]="ipBoard?.otherSideBoardPart?.sticker"
        [type]="infoType"
      >
      </sign-info>
    </ng-container>
  `,
})
export class SignInfoWrapperComponent {
  @Input() client!: boolean;
  @Input() ipBoard: IPBoard;
  @Input() infoType: InfoType;
}
